import { useEffect } from 'react'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useDispatch } from 'react-redux'
import { upsertInformalFeedbackRequest } from 'redux/actions/informalFeedbackRequests'
import { useQueryClient } from 'react-query'
import { InformalFeedbackRequest } from '../../api/clients/InformalFeedbackRequestsClient'
import { useInformalFeedbackRequests } from './useInformalFeedbackRequests'
import { useRefreshInformalFeedbackRequests } from 'hooks/useRefreshInformalFeedbackRequests'

const WS_CHANNEL_NAME = 'Workflows::InformalFeedbackRequestChannel'

export const useInformalFeedbackRequestRealtimeChannel = (almanacFileId: string) => {
  const websocketConnection = useWebsocketConnection()
  const queryClient = useQueryClient()
  const { openRequest } = useInformalFeedbackRequests(almanacFileId)
  const { refreshRequests } = useRefreshInformalFeedbackRequests({
    almanacFileId,
    requestId: openRequest?.id,
  })
  const dispatch = useDispatch()

  useEffect(() => {
    if (!openRequest || !websocketConnection) {
      return
    }

    const subscription = websocketConnection.subscriptions.create(
      {
        channel: WS_CHANNEL_NAME,
        id: openRequest.id,
      },
      {
        received: (data: { informal_feedback_request: InformalFeedbackRequest }) => {
          const request = data.informal_feedback_request
          refreshRequests()
          dispatch(upsertInformalFeedbackRequest(request))
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [websocketConnection, openRequest, dispatch, queryClient, refreshRequests])
}
